import React from 'react';
import classname from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import LogoImage from '../../public/images/logo.png';
import NextLink from '../NextLink';
import route from '../../constants/routes';

const useStyles = makeStyles({
  logo: {
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    height: 18,
    width: 180,
  },
});

const Logo = ({ className }) => {
  const classes = useStyles();
  return (
    <NextLink href={route.HOME}>
      <div className={classname(classes.logo, className)} style={{ backgroundImage: `url(${LogoImage})` }} />
    </NextLink>
  );
};

export default Logo;
